import {
  allTraitsDefaultSelector,
  eatFreshTraitsDefaultSelector,
  beProductiveTraitsDefaultSelector,
  stayActiveTraitsDefaultSelector,
  eatFreshTipsDefaultSelector,
  stayActiveTipsDefaultSelector,
  beProductiveTipsDefaultSelector,
  restAndRejuvenateTipsDefaultSelector,
  allEatFreshTraitsDefaultSelector,
  allStayActiveTraitsDefaultSelector,
  allBeProductiveTraitsDefaultSelector,
  skinTraitsDefaultSelector,
  allergyTraitsDefaultSelector,
  hairTraitsDefaultSelector,
} from 'dataLayer/recoil/pages/sections/defaultSelectors';
import { atom } from 'recoil';

export const allTraitsAtom = atom({
  key: 'apiData/pages/sections/atoms/allTraits',
  default: allTraitsDefaultSelector,
});

export const eatFreshTraitsAtom = atom({
  key: 'apiData/pages/sections/atoms/eatFreshTraits',
  default: eatFreshTraitsDefaultSelector,
});

export const stayActiveTraitsAtom = atom({
  key: 'apiData/pages/sections/atoms/stayActiveTraits',
  default: stayActiveTraitsDefaultSelector,
});

export const skinTraitsAtom = atom({
  key: 'apiData/pages/sections/atoms/skinTraits',
  default: skinTraitsDefaultSelector,
});

export const allergyTraitsAtom = atom({
  key: 'apiData/pages/sections/atoms/allergyTraits',
  default: allergyTraitsDefaultSelector,
});

export const hairTraitsAtom = atom({
  key: 'apiData/pages/sections/atoms/hairTraits',
  default: hairTraitsDefaultSelector,
});

export const beProductiveTraitsAtom = atom({
  key: 'apiData/pages/sections/atoms/beProductiveTraits',
  default: beProductiveTraitsDefaultSelector,
});

export const allEatFreshTraitsAtom = atom({
  key: 'apiData/pages/sections/atoms/allEatFreshTraits',
  default: allEatFreshTraitsDefaultSelector,
});

export const allStayActiveTraitsAtom = atom({
  key: 'apiData/pages/sections/atoms/allStayActiveTraits',
  default: allStayActiveTraitsDefaultSelector,
});

export const allBeProductiveTraitsAtom = atom({
  key: 'apiData/pages/sections/atoms/allBeProductiveTraits',
  default: allBeProductiveTraitsDefaultSelector,
});

export const eatFreshTipsAtom = atom({
  key: 'apiData/pages/sections/atoms/eatFreshTips',
  default: eatFreshTipsDefaultSelector,
});

export const stayActiveTipsAtom = atom({
  key: 'apiData/pages/sections/atoms/stayActiveTips',
  default: stayActiveTipsDefaultSelector,
});

export const beProductiveTipsAtom = atom({
  key: 'apiData/pages/sections/atoms/beProductiveTips',
  default: beProductiveTipsDefaultSelector,
});

export const restAndRejuvenateTipsAtom = atom({
  key: 'apiData/pages/sections/atoms/restAndRejuvenateTipsAtom',
  default: restAndRejuvenateTipsDefaultSelector,
});
